<div class="cart-empty-block">
    <div class="cart-empty-block__inner" directive-lottie="empty-cart">
    </div>
</div>